// externals
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

// selectors
import * as tradeInSelectors from '../../../store/mmd/tradeIn';
import { getNextStepInfo } from '../../../store/mmd/navigationCard';

// actions
import * as tradeInActionCreators from '../../../store/actionCreators';

// components

// interfaces/types
import { IRootProps } from '../../../components/RootProps';
import { MultiTradeInUIStateProps } from '../../../types';
import { addTradeIn, toggleAccordionState } from '../../../store';
import { navigateTo } from '@makemydeal/dr-activities-common';
import MultiTradeInUI from './MultiTradeInUI';

export const mapStateToProps = (state: any, ownProps: IRootProps): MultiTradeInUIStateProps => {
    const multiTradeInState = tradeInSelectors.getMultiTradeInsState(state);
    const isMultiTradeInsEnabled = tradeInSelectors.isMultiTradeInsEnabled(state) || true;
    const tradeInSummary = tradeInSelectors.getTradeInSummary(state);
    const headerTitle = 'Trade-In';
    const nextStepInfo = getNextStepInfo(state);
    const actionButtonText = nextStepInfo ? nextStepInfo.title : '';

    return {
        ...ownProps,
        headerTitle,
        multiTradeInState,
        isMultiTradeInsEnabled,
        tradeInSummary,
        actionButtonText
    };
};

export const mapDispatchToProps = (dispatch: any) => {
    return {
        addTradeIn: () => {
            dispatch(addTradeIn());
        },
        toggleAccordionState: (index) => {
            dispatch(toggleAccordionState(index));
        },
        removeTradeIn: () => {
            dispatch(tradeInActionCreators.removeTradeIn());
        },
        goToNextStep: () => {
            dispatch((dispatch, getState) => {
                const state = getState();
                const nextStepInfo = getNextStepInfo(state);
                if (nextStepInfo) {
                    dispatch(tradeInActionCreators.tradeInCompletedContinue());
                    dispatch(tradeInActionCreators.continueToNextActivityPress(nextStepInfo.route));
                    dispatch(navigateTo(nextStepInfo.route));
                }
            });
        }
    };
};

const MultiTradeIn = withRouter(connect(mapStateToProps, mapDispatchToProps)(MultiTradeInUI) as any);

export default MultiTradeIn;
